import {
  GridFooterContainer,
  gridRowSelectionCountSelector,
  useGridApiContext,
  useGridSelector,
  gridFilteredTopLevelRowCountSelector,
  gridRowCountSelector,
} from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getFooterText } from './utils';

export const EvacuationZonesFooter = (): JSX.Element => {
  const { t } = useTranslation();
  const apiRef = useGridApiContext();
  const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
  const visibleRowCount = useGridSelector(
    apiRef,
    gridFilteredTopLevelRowCountSelector,
  );
  const selectedRowCount = useGridSelector(
    apiRef,
    gridRowSelectionCountSelector,
  );

  return (
    <GridFooterContainer>
      <Typography sx={{ p: 2 }}>
        {getFooterText(totalRowCount, visibleRowCount, selectedRowCount, t)}
      </Typography>
    </GridFooterContainer>
  );
};
